import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KamonaOtpVersion } from '../kamona-otp/kamona-otp.component';
import { CustomTimelineVersion } from '../../model/kamonal-model';

@Component({
    selector: 'app-kamona-passcode-widget',
    templateUrl: './kamona-passcode-widget.component.html',
    styleUrls: ['./kamona-passcode-widget.component.scss'],
})
export class KamonaPasscodeWidgetComponent implements OnInit {
    @Input() version = CustomTimelineVersion.version_7;
    @Output() emitSubmit = new EventEmitter();
    @Output() emitBack = new EventEmitter();
    @Input() submitting: boolean;
    @Input() usePasscodeForm = true;
    @Input() title: string;
    @Input() minHeight = 510;
    @Input() hideBackBtn = false;
    @Input() description: string;
    @Input() currentStep: number;
    @Input() hideHeader = false;
    @Input() previousTitle: string;
    @Input() totalStep: number;
    @Input() noOfPasscodeBox = 6;
    @Input() newPasscodeLabel = 'Enter new Passcode';
    @Input() confirmPasscodeLabel = 'Confirm new Passcode';
    @Input() useConfirmPasscode = true;
    @Input() totalAllowableKeyIndex = 5;
    readonly KamonaOtpVersion = KamonaOtpVersion;
    loading = true;
    newPasscode: string;
    confirmPasscode: string;
    @Input() btnText = 'Done';
    @Input() cancelBtnText = 'Back';
    constructor() {}

    ngOnInit(): void {}

    setPasscode($event: any) {
        if (this.submitting) {
            return;
        }
        this.emitSubmit.emit($event);
    }

    setNewPasscode(passcode: string) {
        this.newPasscode = passcode;
        this.emitPasscode(passcode);
        if (!this.useConfirmPasscode) {
            this.confirmPasscode = passcode;
        }
    }

    emitPasscode(passcode: string) {
        if (this.usePasscodeForm) {
            return;
        }
        this.emitSubmit.emit(passcode);
    }

    setConfirmPasscode(passcode: string) {
        this.confirmPasscode = passcode;
    }

    submit() {
        if (this.submitting) {
            return;
        }
        const newPasscode = this.newPasscode;
        const confirmPasscode = this.confirmPasscode;
        this.emitSubmit.emit({ newPasscode, confirmPasscode });
    }

    goBack() {
        if (this.submitting) {
            return;
        }
        this.emitBack.emit();
    }
}
